import React, { useState, useMemo, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { createTypography } from '@one-thd/sui-atomic-components';
import { ButtonBase } from '@one-thd/sui-atomic-components/dist/private/components/button/ButtonBase';

const ViewChangerButton = (props) => {
  const {
    ariaLabel,
    children,
    disabled = false,
    onClick
  } = props;

  const typography = createTypography({
    variant: 'body-base',
    weight: 'bold',
    color: 'primary'
  });
  const navigationButtonClasses = classNames(
    'sui-flex sui-items-center focus-visible:sui-outline-strongest focus-visible:sui-outline-1 sui-outline-offset-1',
    !disabled && 'hover:sui-underline',
    typography.classes
  );

  return (
    <>
      <ButtonBase
        aria-label={ariaLabel}
        aria-live="polite"
        disabled={disabled}
        unstyled
        onClick={onClick}
        className={navigationButtonClasses}
      >
        {children}
      </ButtonBase>
    </>
  );
};

ViewChangerButton.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};

export { ViewChangerButton };
